import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LibItem, UserShortInfo } from "../../types";
import ManShortSelector from "../../components/ui/shortItemSelect";
import {
  backend,
  GroupData,
} from "../../services";
import { RootState } from "../../state/reducer";
import { toast } from "sonner";
import { currentUserGroupFilter } from "../../state/functions";

interface ModalLoaderProps {
  group_id: number;
  group_name: string;
  onSave: () => void;
  closeModal: () => void;
}

const DeleteGroupModal: React.FC<ModalLoaderProps> = ({
  group_id,
  group_name,
  onSave,
  closeModal,
}) => {
  const State = useSelector((state: RootState) => state);
  const session = State.session;
  if (!session?.id) {
    return null;
  }
  const groupList = State.groupsToSelect;
  const [groupToTransfer, setGroupToTransfer] = useState<number | undefined>()


  const closeWithSave = async () => {
    console.log("Close with save called");
    await saveAction();
    onSave(); // Передаем новое фото в callback
    closeModal(); // Закрываем модальное окно
  };

  useEffect(() => {
    setGroupToTransfer(groupList[0].id);
  }, [groupList]);

  const saveAction = async () => {
    return new Promise((resolve) => {
      backend
        .deleteGroup({
          group_id,
          group_transfer_id: groupToTransfer
        })
        .then(() => {
          onSave();
          toast("Группа удалена");
          resolve(1)
        })
        .catch(() => {
          toast("Ошибка удаления группы");
          resolve(0)
        });
    });
  };

  return (
    <div className="creationForm">
      <div className="modalHeading">
        <h3>{`Удаление группы ${group_name || ""}`}</h3>
      </div>
      <form className="columnCenter">
        <div className="flex between w100 formRow">
          <label>Перенести пользователей в группу</label>
          <div className="fieldInput flex">
            <select
              id="parent_group_id"
              name="parent_group_id"
              value={groupToTransfer}
              onChange={(event) => setGroupToTransfer(Number(event.target.value))}
            >
              {groupList.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        {/* Кнопки действий */}
        <div className="flex between btnRow">
          <button
            className="filterButton red"
            type="button"
            onClick={closeWithSave}
          >
            Удалить
          </button>
          <button className="cancelButton" type="button" onClick={closeModal}>
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
};

export default DeleteGroupModal;
